export default [
	{
		path: '/eight_min',
		name: 'eight_min',
		meta: {
			exp: '8分钟路演首页',
			requireAuth: false
		},
		component: () => import('@/views/eight_min/home/index.vue')
	},
	{
		path: '/redirect_page/:path*',
		name: 'redirect_page',
		meta: {
			exp: '重定向页面',
			requireAuth: false
		},
		component: () => import('@/views/eight_min/redirect_page/index.vue')
	},
	// {
	// 	path: '/announcement',
	// 	name: '8min_announcement',
	// 	meta: {
	// 		exp: '8分钟路网站公告',
	// 		requireAuth: false
	// 	},
	// 	component: () => import('@/views/eight_min/live/announcement/index.vue')
	// },
	{
		path: '/eight_min_road_show',
		name: '8min_road_show',
		meta: {
			exp: '8分钟路演大厅列表',
			requireAuth: false
		},
		component: () => import('@/views/eight_min/road_show/index.vue')
	},
	{
		path: '/eight_min_road_play',
		name: '8min_road_play',
		meta: {
			exp: '8分钟路演大厅播放页',
			requireAuth: false
		},
		component: () => import('@/views/eight_min/road_show/children/road_play/index.vue')
	},
	// {
	// 	path: '/about_us',
	// 	name: '8min_about_us',
	// 	meta: {
	// 		exp: '8分钟路演关于我们',
	// 		requireAuth: false
	// 	},
	// 	component: () => import('@/views/eight_min/about_us/index.vue')
	// },
	// {
	// 	path: '/live',
	// 	name: '8min_live',
	// 	meta: {
	// 		exp: '8分钟路演直播列表',
	// 		requireAuth: false
	// 	},
	// 	component: () => import('@/views/eight_min/live/index.vue')
	// },
	// {
	// 	path: '/live_play',
	// 	name: '8min_live_play',
	// 	meta: {
	// 		exp: '8分钟路演直播列表',
	// 		requireAuth: false
	// 	},
	// 	component: () => import('@/views/eight_min/live/children/live_play/index.vue')
	// },
	// {
	// 	path: '/enterprise_interview',
	// 	name: '8min_enterprise_interview',
	// 	meta: {
	// 		exp: '8分钟路演企业专访',
	// 		requireAuth: false
	// 	},
	// 	component: () => import('@/views/eight_min/enterprise_interview/index.vue')
	// },
	// {
	// 	path: '/enterprise_detail',
	// 	name: '8min_enterprise_detail',
	// 	meta: {
	// 		exp: '8分钟路演企业专访详情页',
	// 		requireAuth: false
	// 	},
	// 	component: () => import('@/views/eight_min/enterprise_interview/children/enterprise_detail/index.vue')
	// },
	{
		path: '/eight_min_hot_activity',
		name: '8min_hot_activity',
		meta: {
			exp: '8分钟路演热门活动',
			requireAuth: false
		},
		component: () => import('@/views/eight_min/hot_activity/index.vue')
	},
	{
		path: '/eight_min_activity_detail',
		name: '8min_activity_detail',
		meta: {
			exp: '8分钟路演热门活动详情',
			requireAuth: false
		},
		component: () => import('@/views/eight_min/hot_activity/children/activity_detail/index.vue')
	},
	// {
	// 	path: '/investor',
	// 	name: '8min_investor',
	// 	meta: {
	// 		exp: '8分钟路演投资人',
	// 		requireAuth: false
	// 	},
	// 	component: () => import('@/views/eight_min/investor/index.vue')
	// },
	// {
	// 	path: '/organ',
	// 	name: '8min_organ',
	// 	meta: {
	// 		exp: '8分钟路演投资机构',
	// 		requireAuth: false
	// 	},
	// 	component: () => import('@/views/eight_min/organ/index.vue')
	// },
	{
		path: '/eight_min_highlight_replays',
		name: '8min_highlight_replays',
		meta: {
			exp: '8分钟路演精彩回放列表',
			requireAuth: false
		},
		component: () => import('@/views/eight_min/highlight_replays/index.vue')
	},
	{
		path: '/eight_min_hr_detail',
		name: '8min_hr_detail',
		meta: {
			exp: '8分钟路演精彩回放详情',
			requireAuth: false
		},
		component: () => import('@/views/eight_min/highlight_replays/children/hr_detail/index.vue')
	},
	{
		path: '/eight_min_dcim',
		name: '8min_dcim',
		meta: {
			exp: '8分钟路演精彩回放详云相册',
			requireAuth: false
		},
		component: () => import('@/views/eight_min/highlight_replays/children/dcim/index.vue')
	},
	// {
	// 	path: '/faq',
	// 	name: '8min_faq',
	// 	meta: {
	// 		exp: '8分钟常见问题',
	// 		requireAuth: false
	// 	},
	// 	component: () => import('@/views/eight_min/help_center/faq/index.vue')
	// },
	// {
	// 	path: '/user_protocol',
	// 	name: '8min_user_protocol',
	// 	meta: {
	// 		exp: '8分钟用户协议',
	// 		requireAuth: false
	// 	},
	// 	component: () => import('@/views/eight_min/help_center/agreement/user_protocol.vue')
	// },{
	// 	path: '/privacy_clauset',
	// 	name: '8min_privacy_clauset',
	// 	meta: {
	// 		exp: '8分钟隐私条款',
	// 		requireAuth: false
	// 	},
	// 	component: () => import('@/views/eight_min/help_center/agreement/privacy_clauset.vue')
	// },
	{
		path: '/eight_min_competition',
		name: 'competition_list',
		meta: {
			exp: '比赛大厅',
			requireAuth: false
		},
		component: () => import('@/views/eight_min/competition/list')
	},
	{
		path: '/eight_min_competition_detail',
		name: 'competition_detail',
		meta: {
			exp: '比赛大厅-详情',
			requireAuth: false
		},
		component: () => import('@/views/eight_min/competition/detail')
	},
]
